import * as React from 'react';
import PropTypes from 'prop-types';
import Slider, { SliderThumb } from '@material-ui/core/Slider';
import { styled, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
const useStyles = makeStyles((theme) => ({
  sliderLabel: {
    color: "#002D55",
    fontWeight: "bold",
    marginBottom: 8,
    marginTop: 8,
    marginLeft: 0,
    marginRight: 0,
    textAlign: "left",
    fontSize: 'clamp(1.1rem, 2vw, 1.5rem)',
    [theme.breakpoints.up('md')]: { fontSize: '1.2rem', marginTop: 0 },
    [theme.breakpoints.down('md')]: { fontSize: '1.05rem', marginTop: 0 },
    [theme.breakpoints.down('sm')]: { fontSize: '0.95rem', marginTop: 0 },
    [theme.breakpoints.down('xs')]: { fontSize: '0.9rem', marginTop: 0 }
  },
}));

const Root = styled('div')(
  ({ theme }) => `
  width: calc(300px + ${theme.spacing(6)});
  max-width: 100%;
  box-sizing: border-box;
  ${theme.breakpoints.down('md')} {
    width: calc(240px + ${theme.spacing(4)});
  }
  ${theme.breakpoints.down('sm')} {
    width: calc(200px + ${theme.spacing(3)});
  }
`,
);

const Separator = styled('div')(
  ({ theme }) => `
  height: ${theme.spacing(3)};
`,
);

function ValueLabelComponent(props) {
  const { children, value } = props;

  return (
    <Tooltip enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  );
}

ValueLabelComponent.propTypes = {
  children: PropTypes.element.isRequired,
  value: PropTypes.number.isRequired,
};

const iOSBoxShadow =
  '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)';

  const marks = [
    {
      value: 0,
      label: '0',
    },
    {
      value: 30,
      label: '30',
    },
    {
      value: 40,
      label: '40',
    },
    {
      value: 50,
      label: '50',
    },
    {
      value: 60,
      label: '60',
    },
    {
      value: 70,
      label: '70',
    },
    {
      value: 100,
      label: '100',
    },
  ];
  
  function valuetext(value) {
    return `${value}°C`;
  }
  
  function valueLabelFormat(value) {
    return marks.findIndex((mark) => mark.value === value) + 1;
  }

  //function MyThumbComponent(props) {
  //if (props['data-index'] == 0) {
  //  props.style.backgroundColor = "green"
  //} else if (props['data-index'] == 1) {
  //  props.style.backgroundColor = "red"
  //}
  //return (
  //  <span {...props}>
  //  </span>
  //);
  //}
  
  const PrettoSlider = styled(Slider)(({ theme }) => ({
    color: '#ffffff',
    height: 5,
    marginLeft: 8,
    width: "95%",
    [theme.breakpoints.down('md')]: {
      marginLeft: 6,
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: 4,
    },
    '& .MuiSlider-thumb': {
      height: 22,
      width: 22,
      backgroundColor: '#fff',
      border: '2px solid #fb741a',
      marginTop: -10,
      marginLeft: -12,
      [theme.breakpoints.down('md')]: {
        height: 18,
        width: 18,
        marginTop: -8,
        marginLeft: -9,
      },
      [theme.breakpoints.down('sm')]: {
        height: 16,
        width: 16,
        marginTop: -7,
        marginLeft: -8,
      },
      '&:focus, &:hover, &.Mui-active': {
        boxShadow: 'inherit',
      },
    },
    '& .MuiSlider-valueLabel': {
      left: 'calc(-25% + 0px)',
      color: "#1a90ff",  
      scale: (0.01)
    },
    '& .MuiSlider-track': {
      height: 15,
      borderRadius: 4,
      opacity: 0.01,
      color: "linear-gradient(90deg, rgb(117,252,117) 0%, rbg(255,255,0) 50%,)",
      [theme.breakpoints.down('md')]: {
        height: 12,
      },
      [theme.breakpoints.down('sm')]: {
        height: 10,
      },
    },
    '& .MuiSlider-rail': {
      height: 15,
      borderRadius: 10,
      background: "linear-gradient(90deg, #17aa2d 25%, #FF0000 90%)", 
      margin: -6,
      width: 'calc(100% + 12px)',
      [theme.breakpoints.down('md')]: {
        height: 12,
        margin: -5,
        width: 'calc(100% + 10px)',
      },
      [theme.breakpoints.down('sm')]: {
        height: 10,
        margin: -4,
        width: 'calc(100% + 8px)',
      },
    },
    '& .MuiSlider-markLabel': {
      fontSize: 18,
      fontWeight: 400,
    color: '#002D55',
    fontSize: 'clamp(0.95rem, 1.5vw, 1rem)',
    [theme.breakpoints.down('xl')]: { fontSize: '1.05rem' },
    [theme.breakpoints.down('lg')]: { fontSize: '1.0rem' },
    [theme.breakpoints.down('md')]: { fontSize: '0.9rem' },
    [theme.breakpoints.down('sm')]: { fontSize: '0.88rem' },
    [theme.breakpoints.down('xs')]: { fontSize: '0.8rem' },
    },
  }));


export default function PainSlider(props) {
  const classes = useStyles();
  return (
    <Root>
      <Typography
        variant="h5"
        classes={{ root: classes.sliderLabel }}
      >
        How was the pain level?
      </Typography>
      <PrettoSlider
        valueLabelFormat={valueLabelFormat}
        getAriaValueText={valuetext}
        aria-labelledby="discrete-slider-restrict"
        defaultValue={5}
        onChange={(event, val) => {
          props.setValue(val)
        }}
        value={props.value}
        valueLabelDisplay="auto"
        marks={marks}
      />
    </Root>
  );
}
